import { createContext } from 'react';

const SessionHttpContext = createContext({
  isLoading: false,
  httpResponse: {} as Response | null,
});

export default SessionHttpContext;
